<ng-container *ngIf="organization$ | async as organization">
  <ng-container *ngIf="activity$ | async as activity">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid justify-content-start">
        <a
          class="btn btn-light me-1 me-sm-3 d-none d-sm-inline"
          style="vertical-align: top"
          [routerLink]="['/organization', organization.id]"
          ><span class="material-icons-outlined align-middle">view_compact_alt</span
          ><span class="d-none d-xl-inline align-middle ms-1 d-none">{{ organization.name }}</span></a
        >
        <button
          class="navbar-toggler me-1"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#activityNavigation"
          aria-controls="activityNavigation"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <a class="navbar-brand" [routerLink]="['organization', organization.id, 'activities', activity.id]">
          <span class="d-inline d-sm-none fs-6">
            <span>{{ activity.name.substring(0, 38) }}</span>
            <span *ngIf="activity.name.length >= 38">...</span>
            <span class="d-block text-smallest">{{ organization.name }}</span>
          </span>

          <span class="d-none d-sm-inline">{{ activity.name }}</span>
        </a>
        <div class="collapse navbar-collapse" id="activityNavigation">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item me-2 py-2 py-sm-0 d-inline d-sm-none">
              <a class="nav-link" [routerLink]="['/organization', organization.id]"
                ><img
                  *ngIf="organization.logoUrl"
                  style="width: 28px"
                  class=""
                  [src]="organization.logoUrl"
                  alt="{{ organization.name }}'s logo" /><span class="align-middle ms-1">{{ organization.name }}</span></a
              >
            </li>
            <li class="nav-item me-2 py-2 py-sm-0">
              <a
                class="nav-link"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="['organization', organization.id, 'activities', activity.id]"
                routerLinkActive="active"
                ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">analytics</span
                ><span class="align-middle ms-1">Översikt</span></a
              >
            </li>
            <li class="nav-item me-4 py-2 py-sm-0" *ngIf="activity.type !== 'kakservice'">
              <a
                class="nav-link position-relative"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
                routerLinkActive="active"
                [routerLink]="['organization', organization.id, 'activities', activity.id, 'products']"
                ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">category</span
                ><span class="align-middle ms-1">Produkter/avgifter</span
                ><small
                  *ngIf="activity.products.length === 0"
                  class="d-none d-lg-inline position-absolute start-100 translate-middle badge rounded-pill bg-danger text-smallest">
                  !
                </small></a
              >
            </li>

            <li class="nav-item me-4 py-2 py-sm-0" *ngIf="activity.type !== 'template' && activity.type !== 'kakservice'">
              <a
                class="nav-link position-relative"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
                routerLinkActive="active"
                [routerLink]="['organization', organization.id, 'activities', activity.id, 'registration']"
                ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">app_registration</span
                ><span class="align-middle ms-1">Anmälan</span>
                <small
                  *ngIf="activity.registration"
                  class="d-none d-lg-inline px-1 position-absolute start-100 translate-middle badge rounded-pill bg-success text-smallest">
                  <span class="material-icons align-middle text-smaller text-smallest">check</span>
                </small>
              </a>
            </li>

            <li class="nav-item me-4 py-2 py-sm-0" *ngIf="activity.type !== 'template'">
              <a
                class="nav-link position-relative"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
                routerLinkActive="active"
                [routerLink]="['organization', organization.id, 'activities', activity.id, 'participants']"
                ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">groups</span
                ><span class="align-middle ms-1">Deltagare</span>
                <ng-container *ngIf="participants$ | async as participants">
                  <small
                    *ngIf="!activity.registration || (activity.registration && participants.length > 0)"
                    class="d-none d-lg-inline position-absolute start-100 translate-middle badge text-smallest rounded-pill"
                    [class.bg-success]="participants.length > 0"
                    [class.text-dark]="participants.length > 0"
                    [class.bg-danger]="participants.length === 0">
                    {{ participants.length === 0 ? '!' : participants.length }}
                  </small>
                </ng-container>
              </a>
            </li>
            <li class="nav-item me-4 py-2 py-sm-0" *ngIf="(anyDeliverableProducts() | async) && activity.type !== 'template'">
              <a
                class="nav-link position-relative"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse.show"
                routerLinkActive="active"
                [routerLink]="['organization', organization.id, 'activities', activity.id, 'delivery']"
                ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">local_shipping</span
                ><span class="align-middle ms-1">Leverans</span>
              </a>
            </li>
            <li class="nav-item py-2 py-sm-0 d-inline d-lg-none">
              <app-support-icon [renderAsMenuOption]="true"></app-support-icon>
            </li>
          </ul>
          <app-support-icon class="me-3 d-none d-lg-inline" [renderAsMenuOption]="false"></app-support-icon>
          <app-account class="me-2"></app-account>
        </div>
      </div>
    </nav>
    <nav class="d-flex d-lg-none mt-2 nav shortcuts">
      <div class="d-flex flex-fill">
        <img
          [src]="activity.imageUrl"
          *ngIf="activity.imageUrl"
          style="height: 30px"
          class="img-fluid ms-2 align-self-center"
          alt="{{ activity.name }}'s aktivitetsbild" />

        <ul class="nav text-secondary pb-2 w-100 mx-2 justify-content-evenly flex-fill">
          <li
            class="nav-item text-center"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="['/organization', organization.id, 'activities', activity.id]"
            routerLinkActive="text-primary active border-bottom border-2 border-primary">
            <span class="material-icons align-middle d-block pt-2">analytics</span>
            <span class="text-smallest text-uppercase">Översikt</span>
          </li>
          <li
            class="nav-item text-center"
            *ngIf="activity.type !== 'kakservice'"
            routerLinkActive="text-primary active border-bottom border-2 border-primary"
            [routerLink]="['/organization', organization.id, 'activities', activity.id, 'products']">
            <span class="material-icons align-middle d-block pt-2">category</span>
            <span class="text-smallest text-uppercase">Produkter/avgifter</span>
          </li>
          <li
            *ngIf="activity.type !== 'template' && activity.type !== 'kakservice'"
            class="nav-item text-center"
            routerLinkActive="text-primary active border-bottom border-2 border-primary"
            [routerLink]="['/organization', organization.id, 'activities', activity.id, 'registration']">
            <span class="material-icons align-middle d-block pt-2">app_registration</span>
            <span class="text-smallest text-uppercase">Anmälan</span>
          </li>
          <li
            *ngIf="activity.type !== 'template'"
            class="nav-item text-center"
            routerLinkActive="text-primary active border-bottom border-2 border-primary"
            [routerLink]="['/organization', organization.id, 'activities', activity.id, 'participants']">
            <span class="material-icons align-middle d-block pt-2">groups</span>
            <span class="text-smallest text-uppercase">Deltagare</span>
          </li>
          <li
            class="nav-item text-center"
            *ngIf="(anyDeliverableProducts() | async) && activity.type !== 'template'"
            routerLinkActive="text-primary active border-bottom border-2 border-primary"
            [routerLink]="['/organization', organization.id, 'activities', activity.id, 'delivery']">
            <span class="material-icons align-middle d-block pt-2">local_shipping</span>
            <span class="text-smallest text-uppercase">Leverans</span>
          </li>
        </ul>
      </div>
    </nav>
  </ng-container>
</ng-container>
